import React, { useEffect, useState } from 'react'
import { Educator } from '../../../../models/_models'
import StudentRow from './StudentRow'

const InlineTeacherInputs = ({ studentData, attributeValue,
                               options, idSortLink, firstNameSortLink, lastNameSortLink, teacherSortLink,
                               gradeSortLink, lteacherSortLink, lgradeSortLink,
                               userTypeSortLink, placeSortLink, season }) => {
  const [teacherId, setTeacherId] = useState(attributeValue);
  const [currentTeacher, setCurrentTeacher] = useState();

  useEffect(() => {
    if (!attributeValue) return;

    Educator.find(attributeValue).then((res) => {
      setCurrentTeacher(res.data)
    })
  }, [teacherId])

  return (
    <>
      <table className="table table-responsive">
        <thead>
        <tr>
          <th style={{ padding: '0px' }} className="responsive-th">

          </th>
          <th style={{ padding: '0px' }} className="responsive-th"
              dangerouslySetInnerHTML={{__html: idSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th">
            Job
          </th>
          <th style={{ padding: '0px' }} className="responsive-th"
              dangerouslySetInnerHTML={{__html: firstNameSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th"
              dangerouslySetInnerHTML={{__html: lastNameSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th" colSpan="2"
              dangerouslySetInnerHTML={{__html: teacherSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th" colSpan="2"
              dangerouslySetInnerHTML={{__html: lteacherSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th"
              dangerouslySetInnerHTML={{__html: gradeSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th"
              dangerouslySetInnerHTML={{__html: lgradeSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th"
              dangerouslySetInnerHTML={{__html: userTypeSortLink }}>
          </th>
          <th style={{ padding: '0px' }} className="responsive-th"
              dangerouslySetInnerHTML={{__html: placeSortLink }}>
          </th>

        </tr>
        </thead>
        <tbody>
        <tr id="newstudentlist" />

        {studentData.map((student) => (
          <StudentRow
            student={student}
            options={options}
            season={season}
          />
        ))}
        </tbody>
      </table>
    </>
  )
};

export default InlineTeacherInputs;
